import React from 'react'
import { ConversionCampaignOffer, OfferMeta } from '../../../../types/conversions'
import LockedOffer from '../LockedOffer/LockedOffer'
import OfferMilestones from '../OfferMilestones/OfferMilestones'
import { Currency } from '../../../../types'

const CreatorCommission:React.FC<{offer: ConversionCampaignOffer, meta: OfferMeta, currency: Currency}> = ({offer, meta, currency}) => {
  return (
    <div>
        {
            offer.milestone_visible ? (
                <div>
                    <OfferMilestones offer={offer} meta={meta} currency={currency} />
                </div>
            ) : (
                <LockedOffer offer={offer} meta={meta} currency={currency} />
            )
        }
    </div>
  )
}

export default CreatorCommission